/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_MainInputs */

const cs_gallery_main = /** @type {(inputs: Gallery_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní / cover`)
};

const en_gallery_main = /** @type {(inputs: Gallery_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main / cover`)
};

/**
* | output |
* | --- |
* | "Main / cover" |
*
* @param {Gallery_MainInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_main = /** @type {((inputs?: Gallery_MainInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_MainInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_main(inputs)
	return cs_gallery_main(inputs)
});